import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCalendar } from "@react-icons/all-files/fa/FaCalendar"
import { SectionContext } from "../context/sectionContext"
import { ConditionContext } from "../context/conditionContext"
import * as moment from "moment"
import { dateFormat1, dateFormat2 } from "../../shared/constant"
import { ErrorContext } from "../context/errorContext"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import range from "lodash/range"
import { getYear, getMonth } from "date-fns"
import { JourneyContext } from "../context/journeyContext"
import { getAge, getValueFromJourney, isEquitasChannel } from "../services/helperFunctions"
import { lineCapital, maskInFormat } from "../../shared/functions"
import CkycProposer from "../sections/ckycProposer"
import DateHeaderSelect from "./DateHeaderSelect"
import * as lookup from "../../../static/lookup.json"

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const DateContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 15px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 14px;
  color: #505050;
  float: left;

  & > .date-input {
    display: flex;
    position: revert;
    border: 1px solid #929292;
    padding: 0;
    padding-left: 10px;
    z-index: 2;
    .react-datepicker-popper {
      z-index: 100 !important ;
      transform: translate(26px, 69px) scale(1.2) !important;
      left: 8rem !important;
      top: 0 !important;
      @media screen and (max-width: 767px) {
        transform: translate(26px, 69px) scale(1.2) !important;
        left: 4rem !important;
      }
    }
    

    input {
      width: 100%;
      border: none;
      outline: none;
      z-index: 5;
      background: transparent;
      ${isIE => {
    if (isIE) return `line-height: 1;`
  }}

      &:before {
        content: attr(value);
      }

      &[value=""]:before {
        content: attr(format);
      }

      &::-webkit-calendar-picker-indicator {
        color: rgba(0, 0, 0, 0);
        opacity: 0;
        cursor: pointer;
      }

      &::-webkit-datetime-edit,
      &::-webkit-inner-spin-button,
      &::-webkit-clear-button {
        opacity: 0;
      }
    }

    .input-icon {
      position: absolute;
      right: 1rem;
      cursor: pointer;
      bottom: -0.6rem;
      font-size: 1.5rem;
      & > * {
        color: ${props =>
    props.channel === "A"
      ? "#db0011"
      : props.channel === "B"
        ? "#a20a3a"
        : props.channel === "C"
          ? "#fec32b"
          : "#eb7f25"};
        color: var(--lumiq-tertiary);
      }
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 2px;
    color: #505050;
    font-size: 14px;
    background: ${props =>
    props.channel === "A"
      ? "#ededed"
      : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 0;
    position: relative;
    display: inline-block;
    cursor: default;
    max-width: 100%;
  }
  .react-datepicker .react-datepicker__header.react-datepicker__header--custom > div{
   line-height:1.5 !important;
  }
  .react-datepicker__week{
    line-height:1 !important;
  }
  .react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{
    line-height:1.3rem !important;
    width:1.3rem !important;
  }
  
  @media (max-width: 1200px) {
    .responsive-calendar {
      font-size: 7px !important;
    }
  }
  
  @media (max-width: 768px) {
    .responsive-calendar {
      font-size: 6px !important;
    }
  }
  
`

export default function ComponentTextInputDate(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState, fieldRefs, crollToFirstError, scrollFieldToTop] = useContext(ErrorContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const years = range(1920, getYear(new Date()) + (props.data.futureYearValue ? props.data.futureYearValue : 10), 1)
  const ProductJourneyId = [
    "guaranteedSavingsOption",
     "GuarateedOnePayJourney",
     "guaranteedIncomeAdvantage",
     "jeevanNivesh",
     "moneyBackAdvantage",
     "invest4GJourney",
     "insureSmart",
     "smartJuniorPlan",
     "secureBhavishyaJourney",
     "guaranteedFortuneJourney",
     "IGFPPlusJourney",
     "guaranteedIncome4LifeJourney",
     "GAINjourney"
  ]
  let pickerRef = React.createRef()
  const [isFocus, setIsFocus] = useState(false)

  const getMaxDate = () => {
    // if(props.data.formControlKey === "dob"){
    //   const currentDate = new Date();
    //   const start = new Date(currentDate.getFullYear()-18, currentDate.getMonth(), currentDate.getDate());
    //   const diff = currentDate - start;
    //   const oneDay = 1000 * 60 * 60 * 24;
    //   const day = Math.floor(diff / oneDay);
    //   let maxDateInEpoch = currentDate.setDate(currentDate.getDate() - day);
    //   let maxDate = new Date(maxDateInEpoch);
    //   return moment(maxDate).format(dateFormat2);
    //   return maxDateInEpoch;
    // } else
    if (props.data.max_age || props.data.max_age === 0) {
      let currentDate = new Date()
      let maxDateInEpoch = currentDate.setDate(
        currentDate.getDate() - props.data.max_age
      )
      let maxDate = new Date(maxDateInEpoch)
      return maxDateInEpoch
    } else {
      return
    }
  }
  const getMinDate = () => {
    // if(props.data.formControlKey === "dob"){
    //   const currentDate = new Date();
    //   const start = new Date(currentDate.getFullYear()-65, currentDate.getMonth(), currentDate.getDate());
    //   const diff = currentDate - start;
    //   const oneDay = 1000 * 60 * 60 * 24;
    //   const day = Math.floor(diff / oneDay);
    //   let maxDateInEpoch = currentDate.setDate(currentDate.getDate() - day);
    //   let maxDate = new Date(maxDateInEpoch);
    //   return moment(maxDate).format(dateFormat2);
    //   let minDateInEpoch = currentDate.setDate(currentDate.getDate() - day);
    //   let minDate = new Date(minDateInEpoch);
    //   return minDateInEpoch;
    // } else
    if (props.data.min_age) {
      let currentDate = new Date()
      let minDateInEpoch = currentDate.setDate(
        currentDate.getDate() - props.data.min_age + 1
      )
      let minDate = new Date(minDateInEpoch)
      return minDateInEpoch
    } else {
      return
    }
  }

  const ageValidation = age => {
    if (journeyState.journeyIdFromStrapi == "FlexiEdgeJourney" && props.data.formControlKey === "dateOfBirth") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeResidenceandOccupationDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "FlexiexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "exactNatureOfOccupation")
      let sectionPersonalDetails = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails")
      let compGroupLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups.findIndex(element => element.componentId === "islifetobeAssuredandProposer")
      let compLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components.findIndex(element => element.formControlKey === "islifetobeAssuredandProposer")
      if (age < 18) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupationForLAminor"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = true
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["islifetobeAssuredandProposer"]: "N",
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.islifetobeAssuredandProposer`]: "N",
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } else {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = false
        if (sectionState.sectionData["exactNatureOfOccupation"] === "717") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["exactNatureOfDuties"]: "",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        }
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    } else if ((journeyState.journeyIdFromStrapi == "titaniumPlusJourney" || journeyState.journeyIdFromStrapi == "alphaWealthPlanJourney") && props.data.formControlKey === "dateOfBirth") {
      let temp = journeyState.journeySteps
      let pageIdToChange
      let sectionIdToChange
      let sectionForLAandProp
      if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        pageIdToChange = "PageTitaniumPlusCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "CFSectionTitaniumPersonelDetails"
      } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        pageIdToChange = "AlphaWealthPlanCalculateFundValuePage"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "AlphaWealthPlanCFpersonelDetailsSection"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAexactNatureOfOccupation")
      let sectionPersonalDetails = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionForLAandProp)
      let compGroupLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups.findIndex(element => element.componentId === "CFislifetobeAssuredandProposer")
      let compLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components.findIndex(element => element.formControlKey === "CFislifetobeAssuredandProposer")
      if (age < 18) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupationForLAminor"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = true
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["CFislifetobeAssuredandProposer"]: "N",
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.CFislifetobeAssuredandProposer`]: "N",
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } else {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = false
        if (sectionState.sectionData["GOPAexactNatureOfOccupation"] === "717") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GOPAexactNatureOfOccupation"]: "",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        }
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    } else if ((ProductJourneyId.includes(journeyState.journeyIdFromStrapi)) && props.data.formControlKey === "GOPAdob") {
      let temp = journeyState.journeySteps
      let pageIdToChange
      let sectionIdToChange
      let sectionForLAandProp
      if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
        pageIdToChange = "PageGuaranteedSavingsCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionGuaranteedSavingsPersonelDetails"
      } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        pageIdToChange = "PageGuaranteedOnePayCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionGOPAPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        pageIdToChange = "PageGuaranteedIncomeAdvantageCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionGuaranteedIncomeAdvantagePersonelDetails"
      } else if (props.journeyIdFromStrapi === "insureSmart") {
        pageIdToChange = "PageInsureSmartCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionInsureSmartPersonelDetails"
      } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
        pageIdToChange = "PageJeevenNiveshCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionJeevanNiveshCalculatePremiumPersonalDetails"
      } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
        pageIdToChange = "PageMoneyBackCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionMoneyBackPersonalDetails"
      } else if (props.journeyIdFromStrapi === "invest4GJourney") {
        pageIdToChange = "PageInvest4GCalculateFundValue"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionInvest4GPersonelDetails"
      } else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
        pageIdToChange = "PageSmartJuniorCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionSmartJuniorPersonelDetails"
      } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
        pageIdToChange = "PageSecureBhavishyaCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionSecureBhavishyaPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        pageIdToChange = "PageGuaranteedFortuneCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionGuaranteedFortunePersonelDetails"
      } else if (props.journeyIdFromStrapi === "IGFPPlusJourney") {
        pageIdToChange = "PageIGFPPlusCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionIGFPPlusPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        pageIdToChange = "PageGuaranteedIncome4LifeCalculatePremium"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "SectionGuaranteedIncome4LifePersonelDetails"
      } else if (props.journeyIdFromStrapi === "GAINjourney") {
        pageIdToChange = "GAINcalculatePremiumPage"
        sectionIdToChange = "SectionCommonResidenceAndOccupation"
        sectionForLAandProp = "GAINpersonalDetailsSection"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAexactNatureOfOccupation")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAexactNatureOfOccupation")
      let sectionPersonalDetails = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionForLAandProp)
      let compGroupLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups.findIndex(element => element.componentId === "GOPAslifetobeAssuredandProposer")
      let compLifeAssured = temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components.findIndex(element => element.formControlKey === "GOPAslifetobeAssuredandProposer")
      if (age < 18) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupationForLAminor"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = true
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAslifetobeAssuredandProposer"]: "N",
            }
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.GOPAslifetobeAssuredandProposer`]: "N",
          }
        })
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      } else {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["lookupKey"] = "natureOfOccupation"
        temp.pages[tempPageIndexToChange].sections[sectionPersonalDetails].component_groups[compGroupLifeAssured].components[compLifeAssured]["disabled"] = false
        if (sectionState.sectionData["GOPAexactNatureOfOccupation"] === "717") {
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["GOPAexactNatureOfOccupation"]: "",
              }
            })
          })
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        }
        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
  }

  const handleAnnualIncome = age => {
    if (journeyState.journeyIdFromStrapi == "FlexiEdgeJourney" && props.data.formControlKey === "dateOfBirth") {
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "annualIncome")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "annualIncome")
      if (age < 18) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["annualIncome"]: "0",
              ["annualIncomeMask"]: "0"
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 0

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["annualIncome"]: "",
              ["annualIncomeMask"]: ""
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 10000

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    } else if ((journeyState.journeyIdFromStrapi == "titaniumPlusJourney" || journeyState.journeyIdFromStrapi == "alphaWealthPlanJourney") && props.data.formControlKey === "dateOfBirth") {
      let pageIdToChange
      let sectionIdToChange
      if (props.journeyIdFromStrapi === "titaniumPlusJourney") {
        pageIdToChange = "PageTitaniumPlusCalculateFundValue"
        sectionIdToChange = "CFSectionTitaniumPersonelDetails"
      } else if (props.journeyIdFromStrapi === "alphaWealthPlanJourney") {
        pageIdToChange = "AlphaWealthPlanCalculateFundValuePage"
        sectionIdToChange = "AlphaWealthPlanCFpersonelDetailsSection"
      }
      let temp = journeyState.journeySteps
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "CFAnnualIncome")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "annualIncome")
      if (age < 18) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["annualIncome"]: "0",
              ["annualIncomeMask"]: "0"
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 0

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["annualIncome"]: "",
              ["annualIncomeMask"]: ""
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 10000

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    } else if ((ProductJourneyId.includes(journeyState.journeyIdFromStrapi)) && props.data.formControlKey === "GOPAdob") {
      let temp = journeyState.journeySteps
      let pageIdToChange
      let sectionIdToChange
      if (props.journeyIdFromStrapi === "guaranteedSavingsOption") {
        pageIdToChange = "PageGuaranteedSavingsCalculatePremium"
        sectionIdToChange = "SectionGuaranteedSavingsPersonelDetails"
      } else if (props.journeyIdFromStrapi === "GuarateedOnePayJourney") {
        pageIdToChange = "PageGuaranteedOnePayCalculatePremium"
        sectionIdToChange = "SectionGOPAPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
        pageIdToChange = "PageGuaranteedIncomeAdvantageCalculatePremium"
        sectionIdToChange = "SectionGuaranteedIncomeAdvantagePersonelDetails"
      } else if (props.journeyIdFromStrapi === "insureSmart") {
        pageIdToChange = "PageInsureSmartCalculateFundValue"
        sectionIdToChange = "SectionInsureSmartPersonelDetails"
      } else if (props.journeyIdFromStrapi === "jeevanNivesh") {
        pageIdToChange = "PageJeevenNiveshCalculatePremium"
        sectionIdToChange = "SectionJeevanNiveshCalculatePremiumPersonalDetails"
      } else if (props.journeyIdFromStrapi === "moneyBackAdvantage") {
        pageIdToChange = "PageMoneyBackCalculatePremium"
        sectionIdToChange = "SectionMoneyBackPersonalDetails"
      } else if (props.journeyIdFromStrapi === "invest4GJourney") {
        pageIdToChange = "PageInvest4GCalculateFundValue"
        sectionIdToChange = "SectionInvest4GPersonelDetails"
      } 
      else if (props.journeyIdFromStrapi === "smartJuniorPlan") {
        pageIdToChange = "PageSmartJuniorCalculatePremium"
        sectionIdToChange = "SectionSmartJuniorPersonelDetails"
      } else if (props.journeyIdFromStrapi === "secureBhavishyaJourney") {
        pageIdToChange = "PageSecureBhavishyaCalculatePremium"
        sectionIdToChange = "SectionSecureBhavishyaPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedFortuneJourney") {
        pageIdToChange = "PageGuaranteedFortuneCalculatePremium"
        sectionIdToChange = "SectionGuaranteedFortunePersonelDetails"
      } else if (props.journeyIdFromStrapi === "IGFPPlusJourney") {
        pageIdToChange = "PageIGFPPlusCalculatePremium"
        sectionIdToChange = "SectionIGFPPlusPersonelDetails"
      } else if (props.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
        pageIdToChange = "PageGuaranteedIncome4LifeCalculatePremium"
        sectionIdToChange = "SectionGuaranteedIncome4LifePersonelDetails"
      } else if (props.journeyIdFromStrapi === "GAINjourney") {
        pageIdToChange = "GAINcalculatePremiumPage"
        sectionIdToChange = "GAINpersonalDetailsSection"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageIdToChange)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionIdToChange)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAannualIncome")
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAannualIncome")
      if (age < 18) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAannualIncome"]: "0",
              ["GOPAannualIncomeMask"]: "0"
            },
          }
        })
        // setErrorState(prev => {
        //   return {
        //     ...prev,
        //     ["GOPAannualIncome"]: "",
        //   }
        // })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 0

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["GOPAannualIncome"]: "",
              ["GOPAannualIncomeMask"]: ""
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
        // temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["min_value"] = 10000

        setJourneyState(prev => {
          return ({
            ...prev,
            journeySteps: temp
          })
        })
      }
    }
  }

  const validate = target => {
    if (props.data.required) {
      // required field validation
      if (
        sectionState.sectionData?.[props.data.formControlKey] === "" ||
        !sectionState.sectionData?.[props.data.formControlKey]
      ) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: props.data.requiredError
              ? (getValueFromJourney(
                journeyState.lookup.required_error,
                props.data.requiredError
              )) : `Error Code Not Found in Strapi`,
          }
        })
      } else {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
      if (target.value) {
        setErrorState(prev => {
          return {
            ...prev,
            [props.data.formControlKey]: "",
          }
        })
      }
    }
    if (target.value) {
      let targetDateInEpoch = target.value

      let currentDateInEpoch = Math.floor(new Date().getTime() / 1000)
      let timeleft = currentDateInEpoch - targetDateInEpoch
      let days = Math.ceil(timeleft / 60 / 60 / 24)

      if (props.data.min_age) {
        // min age validation
        if (days > props.data.min_age) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: lineCapital(
                lookup?.min_error?.[0]?.[props.data.min_age_error] || "" 
              )
            }
          })
          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "",
            }
          })
        }
      }
      if (props.data.max_age) {
        //max age validation
        if (days < props.data.max_age) {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: (getValueFromJourney(
                journeyState.lookup.max_error,
                props.data.max_age_error
              ))
            }
          })
          setShowLocalError(true)
          return
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [props.data.formControlKey]: "",
            }
          })
        }
      }
    }
    setConditionState(prev => {
      return {
        ...prev,
        [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
      }
    })
    // console.log(errorState)
    return
  }

  useEffect(() => {
    validate({
      value: sectionState.sectionData?.[props.data.formControlKey] ?? "",
    })

    handlePicker()
  }, [sectionState.sectionData?.[props.data.formControlKey]])

  const handleChange = target => {
    if (props.data.isMasked){
      setIsFocus(false)
    }
    console.log("22322323", target)
    let dateOfTargetInEpoch = new Date(target).getTime() / 1000
    console.log("223223232", dateOfTargetInEpoch)
    if (sectionState.sectionId === props.sectionId) {
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: dateOfTargetInEpoch,
          },
        }
      })
    } else {
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: dateOfTargetInEpoch,
          },
        }
      })
    }
    validate({ value: dateOfTargetInEpoch })
    if (props.saveApplicationAndCallBi) {
      props.saveApplicationAndCallBi(
        props.data.formControlKey,
        dateOfTargetInEpoch
      )
    }
    let age = getAge(dateOfTargetInEpoch)
    console.log(age, "age")
    ageValidation(age)
    handleAnnualIncome(age)
    //Condition for checking 35 years of policy term
    // handlePolicyTerm(target)
    console.log(sectionState, "section state")
  }

  // This UseEffect CCB option in built screen
  useEffect(() => {
    //Built in cover options 
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPOptionalInBuilt")) {

      let temp = journeyState.journeySteps
      let componentIdKey = "iSelect360CPOptionInBuiltCoversCCB"
      let policyTermKey = "iS360CPCustomizePlanPolicyTermCCB"

      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPOptionalInBuilt")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)

      let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let child_age = getAge(sectionState.sectionData["iS360dobCCB"])

      if (sectionState.sectionData["iS360dobCCB"]) {
        let ageparam = 21 - child_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      } else {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
      }

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPSpouseCoverDetails")) {

      let temp = journeyState.journeySteps
      let componentIdKey = "iSelect360CPSpouseOptionInBuiltCoversCCB"
      let policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCCB"

      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)

      let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let child_age = getAge(sectionState.sectionData["iS360spousedobCCB"])

      if (sectionState.sectionData["iS360spousedobCCB"]) {
        let ageparam = 21 - child_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true
      } else if (!conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iSelect360CPOptionInBuiltCCB"]) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = false
      }

      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [sectionState.sectionData && sectionState.sectionData["iS360dobCCB"], sectionState.sectionData && sectionState.sectionData["iS360spousedobCCB"]])


  // const handlePolicyTerm = age => {
  //   if (
  //     journeyState.journeyIdFromStrapi == "ISelect360Journey" &&
  //     props.sectionId == "CPPersonalDetailsSection"
  //   ) {
  //     let pages = journeyState.journeySteps
  //     let page_id = pages.pages.findIndex(
  //       element => element.pageId === "PageISelect360CalculatePremium"
  //     )
  //     let section_id = pages.pages[page_id].sections.findIndex(
  //       element => element.sectionId === "CPPersonalDetailsSection"
  //     )
  //     let comp_grp_id = pages.pages[page_id].sections[
  //       section_id
  //     ].component_groups.findIndex(
  //       element => element.componentId === "PolicyTerm"
  //     )
  //     let comp_id = pages.pages[page_id].sections[section_id].component_groups[
  //       comp_grp_id
  //     ].components.findIndex(element => element.formControlKey === "policyTerm")
  //     setSectionState(prev => {
  //       return {
  //         ...prev,
  //         sectionId: props.sectionId,
  //         sectionData: {
  //           ...prev.sectionData,
  //           ["policyTerm"]: "",
  //         },
  //       }
  //     })
  //     let default_ptage = 35
  //     let ptdiff = getAge(age)
  //     if (ptdiff >= default_ptage) {
  //       pages.pages[page_id].sections[section_id].component_groups[
  //         comp_grp_id
  //       ].components[comp_id].lookupKey = "policyTermAbove35"
  //     } else {
  //       pages.pages[page_id].sections[section_id].component_groups[
  //         comp_grp_id
  //       ].components[comp_id].lookupKey = "policyTerm"
  //     }
  //     setJourneyState(prev => {
  //       return {
  //         ...prev,
  //         journeySteps: pages,
  //       }
  //     })
  //   }
  // }
  const handlePicker = () => {
    if (pickerRef?.current) {
      let picker = pickerRef?.current.querySelector(".input-icon")
      let calender = pickerRef?.current.querySelector("#datepicker")
      picker.addEventListener("click", () => {
        if (props.data.isMasked){
          setIsFocus(true)
        }
        calender.click()
      })
    }
  }

  let dateInEpoch = sectionState?.sectionData ? sectionState?.sectionData?.[props.data.formControlKey] * 1000 : ''

  return (
    <>
      <DateContainer
        ref={(el) => {
          const key = props.data.formControlKey;

          if (el) {
            fieldRefs.current[key] = el;   // mount
          } else {
            delete fieldRefs.current[key]; // unmount cleanup
          }
        }}
        channel={props.channel}
        className={`form-group input-container ${props.data.disabled ? "disable-input" : ""
          }`}
      >
        <label htmlFor={props.data.id} className="input-label">
          {(getValueFromJourney(
            journeyState.lookup.label,
            props.data.label
          )) || props.data.label}
          {isEquitasChannel(props.channel) && props.data.required && <span className="equitas-required-marker"> *</span>}
        </label>
        <div ref={pickerRef} className="date-input form-control">
          <DatePicker
            id="datepicker"
            selected={
              sectionState.sectionData &&
                sectionState.sectionData[props.data.formControlKey]
                ? sectionState.sectionData[props.data.formControlKey] * 1000
                : ""
            }
            dateFormat={"dd/MMM/yyyy"}
            placeholderText={(getValueFromJourney(
              journeyState.lookup.placeholder,
              props.data.placeholder
            )) || props.data.placeholder}
            autoComplete="true"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (

              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  style={{ marginRight: '5px' }}
                >
                  {/* {"<"} */}
                  <span>
                    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0" />
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                      <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L9.41421 12L15.7071 18.2929C16.0976 18.6834 16.0976 19.3166 15.7071 19.7071C15.3166 20.0976 14.6834 20.0976 14.2929 19.7071L7.29289 12.7071C7.10536 12.5196 7 12.2652 7 12C7 11.7348 7.10536 11.4804 7.29289 11.2929L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289Z" fill="#000000" /> </g>
                    </svg>
                  </span>
                </button>
                <DateHeaderSelect
                  value={getYear(date)}
                  onChange={(value) => changeYear(value)}
                  options={years}
                />

                <DateHeaderSelect
                  value={months[getMonth(date)]}
                  onChange={(value) => changeMonth(months.indexOf(value))}
                  options={months}
                />

                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                  style={{ marginLeft: '5px' }}
                >
                  {/* {">"} */}

                  <span>
                    <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0" />
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                      <g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 4.29289C8.68342 3.90237 9.31658 3.90237 9.70711 4.29289L16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071C7.90237 19.3166 7.90237 18.6834 8.29289 18.2929L14.5858 12L8.29289 5.70711C7.90237 5.31658 7.90237 4.68342 8.29289 4.29289Z" fill="#000000" /> </g>
                    </svg>
                  </span>
                </button>
              </div>
            )}
            minDate={getMinDate()}
            maxDate={getMaxDate()}
            name={+Date.now()}
            disabledKeyboardNavigation={props.data.disabled}
            disabled={props.data.disabled}
            onClickOutside={() => {
              if (props.data.isMasked){
                setIsFocus(false)
              }
            }}
            // onSelect={handleDateSelect} //when day is clicked
            onChange={handleChange} //only when value has changed
            value={
              props.data?.isMasked
                ? isFocus
                  ? dateInEpoch
                  : sectionState?.sectionData?.[props.data.formControlKey]
                  ? maskInFormat(dateInEpoch)
                  : ""
                : dateInEpoch
            }
            onFocus={() => {
              if (props.data?.isMasked) {
                setIsFocus(true)
              }
              scrollFieldToTop(props.data.formControlKey)
            }}
            onBlur={() => {
              if (props.data?.isMasked) {
                setIsFocus(false)
              }
            }}
          />
          {/* <DatePicker
        onChange={(date)=>handleChange(date)}
        format={dateFormat1}
        value={
          sectionState.sectionData[props.data.formControlKey]
            ? moment.unix(
                sectionState.sectionData[props.data.formControlKey]
              ).utcOffset("+05:30").format(dateFormat1).split('T')[0]
            : ""
        }
      /> */}

          {/* <input
            type="date"
            format={dateFormat1}
            placeholder={props.data.placeholder}
            name={props.data.id}
            required={props.data.required}
            disabled={props.data.disabled}
            onChange={handleChange}
            value={
              sectionState.sectionData[props.data.formControlKey]
                ? moment.unix(
                    sectionState.sectionData[props.data.formControlKey]
                  ).utcOffset("+05:30").format(dateFormat1).split('T')[0]
                : ""
            }
            min={getMinDate()}
            max={getMaxDate()}
            //dateFormat={props.data.dateFormat}
            //formControlKey={props.data.formControlKey}
          ></input> */}
          <span className="input-icon" onBlur={() => console.info("sjsjsjs")}>
            <FaCalendar />
          </span>
        </div>
        <span className="input-error2">
          {(props.showError || showLocalError) &&
            errorState[props.data.formControlKey]}
        </span>
      </DateContainer>
    </>
  )
}